import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import client from "@/lib/apiClient";
import { useLang } from "@/i18n";
import { useProperty } from "@/context/PropertyContext";
import { SectionHeader, Loader, Lu } from "@/components/shared";

const IMG = {
  "riyadh-palace": "https://images.unsplash.com/photo-1783260898233-e370da026dee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMHJvb20lMjBzYXVkaSUyMGFyYWJpYSUyMHJpeWFkaCUyMGludGVyaW9yJTIwZHVza3xlbnwwfHx8fDE3ODg5MzkwNzF8MA&ixlib=rb-4.1.0&q=85",
  "jeddah-suites": "https://images.unsplash.com/photo-1675151392946-5231db64c7ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMGxvYmJ5JTIwbW9kZXJuJTIwcmVjZXB0aW9uJTIwc2F1ZGl8ZW58MHx8fHwxNzg4OTM5MDcxfDA&ixlib=rb-4.1.0&q=85",
  "khobar-homes": "https://images.unsplash.com/photo-1758798219572-512a03a60ce0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob3RlbCUyMHJvb20lMjBzYXVkaSUyMGFyYWJpYSUyMHJpeWFkaCUyMGludGVyaW9yJTIwZHVza3xlbnwwfHx8fDE3ODg5MzkwNzF8MA&ixlib=rb-4.1.0&q=85",
};
const PLAN_COLOR = { Premium: "#1E5EFF", Standard: "#3B82F6", Lite: "#10B981" };

export default function Properties() {
  const { t, lang } = useLang();
  const { setSelectedId } = useProperty();
  const [props, setProps] = useState(null);

  useEffect(() => { client.get("/properties").then((r) => setProps(r.data)); }, []);
  if (!props) return <Loader />;

  return (
    <div>
      <SectionHeader icon="building-2" title={t("properties")} subtitle={t("liveData")} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {props.map((p, i) => (
          <motion.div key={p.id} data-testid={`property-${p.id}`}
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.07 }}
            onClick={() => setSelectedId(p.id)}
            className="md-card overflow-hidden cursor-pointer group" whileHover={{ y: -4 }}>
            <div className="relative h-40 overflow-hidden">
              <img src={IMG[p.id]} alt={p.name_en} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 30%, rgba(15,23,42,0.95) 100%)" }} />
              <span className="absolute top-3 ltr:right-3 rtl:left-3 text-xs font-bold px-2.5 py-1 rounded-full"
                style={{ color: "#060A12", background: PLAN_COLOR[p.plan] }}>{p.plan}</span>
              <div className="absolute bottom-3 ltr:left-4 rtl:right-4">
                <p className="text-lg font-bold text-foreground">{p[lang === "ar" ? "name_ar" : "name_en"]}</p>
                <p className="text-xs text-foreground/80 flex items-center gap-1"><Lu name="map-pin" className="w-3 h-3" />{p[lang === "ar" ? "city_ar" : "city_en"]} · {p[lang === "ar" ? "type_ar" : "type_en"]}</p>
              </div>
            </div>
            <div className="p-4 grid grid-cols-3 gap-2 text-center">
              <div><p className="text-xl font-extrabold font-mono text-primary">{p.room_count}</p><p className="text-[10px] text-muted-foreground/70">{t("totalRooms")}</p></div>
              <div><p className="text-xl font-extrabold font-mono text-emerald-400">{p.occupied}</p><p className="text-[10px] text-muted-foreground/70">{t("occupied")}</p></div>
              <div><p className="text-xl font-extrabold font-mono text-foreground/80">{Math.round(p.occupied / p.room_count * 100)}%</p><p className="text-[10px] text-muted-foreground/70">{t("occupancyRate")}</p></div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
